import type { Template } from "@/types";

export const PO_06_H3_V3: Template[] = [
    {
        id: "po-06-h3v3-01",
        name: "PO 01 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_01.png",
        size: [1190, 850],
        style: {},
        slots: [         
            { id: "1", x: 42, y: 180, width: 223, height: 158, rotation: 0, imageRotation: 0 },
            { id: "2", x: 42, y: 346, width: 223, height: 158, rotation: 0, imageRotation: 0 },
            { id: "3", x: 42, y: 512, width: 223, height: 158, rotation: 0, imageRotation: 0 },
            { id: "4", x: 273, y: 180, width: 305, height: 490, rotation: 0, imageRotation: 0 },
            { id: "5", x: 613, y: 211, width: 266, height: 427, rotation: 0, imageRotation: 0 },
            { id: "6", x: 887, y: 211, width: 265, height: 427, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-02",
        name: "PO 02 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_02.png",
        size: [1252, 894],
        style: {},
        slots: [        
            { id: "4", x: 42, y: 155, width: 348, height: 567, rotation: 0, imageRotation: 0 },
            { id: "5", x: 397, y: 155, width: 174, height: 280, rotation: 0, imageRotation: 0 },
            { id: "6", x: 397, y: 442, width: 174, height: 279, rotation: 0, imageRotation: 0 },
            { id: "1", x: 655, y: 155, width: 528, height: 376, rotation: 0, imageRotation: 0 },
            { id: "2", x: 655, y: 538, width: 261, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 923, y: 538, width: 260, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-03",
        name: "PO 03 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_03.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 42, y: 155, width: 528, height: 376, rotation: 0, imageRotation: 0 },
            { id: "2", x: 42, y: 538, width: 261, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 310, y: 538, width: 260, height: 182, rotation: 0, imageRotation: 0 },
            { id: "4", x: 656, y: 155, width: 347, height: 567, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1010, y: 155, width: 174, height: 280, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1010, y: 442, width: 174, height: 279, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-04",
        name: "PO 04 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_04.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 44, y: 141, width: 552, height: 394, rotation: 0, imageRotation: 0 },
            { id: "2", x: 44, y: 542, width: 273, height: 190, rotation: 0, imageRotation: 0 },
            { id: "3", x: 324, y: 542, width: 272, height: 190, rotation: 0, imageRotation: 0 },
            { id: "4", x: 678, y: 190, width: 302, height: 495, rotation: 0, imageRotation: 0 },
            { id: "5", x: 987, y: 190, width: 153, height: 245, rotation: 0, imageRotation: 0 },
            { id: "6", x: 987, y: 442, width: 153, height: 243, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-05",
        name: "PO 05 - H3V3",
        albumType: "Hr",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_05.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 53, y: 85, width: 327, height: 236, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 329, width: 327, height: 235, rotation: 0, imageRotation: 0 },
            { id: "3", x: 53, y: 572, width: 327, height: 235, rotation: 0, imageRotation: 0 },
            { id: "4", x: 387, y: 85, width: 453, height: 722, rotation: 0, imageRotation: 0 },
            { id: "5", x: 975, y: 85, width: 221, height: 357, rotation: 0, imageRotation: 0 },
            { id: "6", x: 975, y: 450, width: 221, height: 357, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-06",
        name: "PO 06 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_06.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 63, y: 167, width: 402, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 63, y: 451, width: 402, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 472, y: 167, width: 118, height: 182, rotation: 0, imageRotation: 0 },
            { id: "4", x: 472, y: 356, width: 118, height: 182, rotation: 0, imageRotation: 0 },
            { id: "5", x: 472, y: 546, width: 118, height: 182, rotation: 0, imageRotation: 0 },
            { id: "6", x: 676, y: 259, width: 527, height: 376, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-07",
        name: "PO 07 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_07.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 63, y: 167, width: 261, height: 427, rotation: 0, imageRotation: 0 },
            { id: "2", x: 63, y: 602, width: 171, height: 125, rotation: 0, imageRotation: 0 },
            { id: "3", x: 331, y: 167, width: 260, height: 427, rotation: 0, imageRotation: 0 },
            { id: "4", x: 241, y: 602, width: 171, height: 125, rotation: 0, imageRotation: 0 },
            { id: "5", x: 420, y: 602, width: 170, height: 125, rotation: 0, imageRotation: 0 },
            { id: "6", x: 764, y: 167, width: 351, height: 560, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-08",
        name: "PO 08 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_08.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 42, y: 201, width: 319, height: 491, rotation: 0, imageRotation: 0 },
            { id: "2", x: 368, y: 201, width: 319, height: 491, rotation: 0, imageRotation: 0 },
            { id: "3", x: 694, y: 201, width: 318, height: 491, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1020, y: 201, width: 191, height: 159, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1020, y: 368, width: 191, height: 158, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1020, y: 534, width: 191, height: 158, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-09",
        name: "PO 09 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_09.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 47, y: 256, width: 116, height: 187, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 450, width: 261, height: 187, rotation: 0, imageRotation: 0 },
            { id: "3", x: 170, y: 256, width: 261, height: 187, rotation: 0, imageRotation: 0 },
            { id: "4", x: 315, y: 450, width: 116, height: 187, rotation: 0, imageRotation: 0 },
            { id: "5", x: 438, y: 256, width: 530, height: 382, rotation: 0, imageRotation: 0 },
            { id: "6", x: 976, y: 256, width: 230, height: 382, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h3v3-10",
        name: "PO 10 - H3V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h3_v3_10.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 0, y: 243, width: 128, height: 200, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 451, width: 128, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 135, y: 243, width: 569, height: 408, rotation: 0, imageRotation: 0 },
            { id: "4", x: 711, y: 243, width: 260, height: 408, rotation: 0, imageRotation: 0 },
            { id: "5", x: 978, y: 243, width: 273, height: 200, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 451, width: 273, height: 200, rotation: 0, imageRotation: 0 }
        ],
    }
];